<form (ngSubmit)="onSubmit()">
  <div fxLayout="column" fxLayoutGap="10px">
    <mat-accordion class="scheme-list">
      @for (scheme of schemes; track scheme) {
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{scheme.name}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <app-opener-scheme [scheme]="scheme" [advertiserId]="advertiserId"
            [clonedLocationFilter]="clonedSchemeLocationFilters[$index]"
            (openerSchemeSaved)="onOpenerSchemeSaved($event)"
            (schemeLocationFilterSaved)="onSchemeLocationFilterSaved($event)"
            (openerSchemeRemoved)="onOpenerSchemeRemoved($event)">
          </app-opener-scheme>
        </mat-expansion-panel>
      }
    </mat-accordion>
    <div class="mt-16">
      <lib-button icon="add" (buttonClick)="onAddScheme()">Add scheme</lib-button>
    </div>
  </div>
</form>
